/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import {
  Modal,
  Grid,
  Button,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
  Box,
} from '@material-ui/core'
import '../../LandingPage/components/LandingActions/LandingActions.scss'

import imageBcie from '../.././../assets/img/image-bcie-3.webp'
import { makeStyles } from '@material-ui/core/styles'
import * as Yup from 'yup'
import { useFormik } from 'formik'

import swal from 'sweetalert'

import { useAuthentication } from '../../../context/authenticationContext'
import { useForm } from '../../../context/formContext'
import Swal from 'sweetalert2'
import { createMiFormByIFI } from '../../../services/Forms/create'
import { getMIPYMEByIFI } from '../../../services/IFI/get'
import { Autocomplete, TextField } from '@mui/material'
import { ReassignUserMiPymeNew } from '../../../services/IFI/create'

const useStyles = makeStyles((theme) => ({
  image: {
    backgroundImage: 'url(' + imageBcie + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('xs')]: {
      visibility: 'hidden',
    },
  },
}))

const ModalChangeUserRegister = ({ open, handleClose, setOpen }) => {
  const { userIDB2C, IdIFIToken } = useAuthentication()
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [checkErrors, setCheckErrors] = useState(false)
  const [data, setData] = useState([])

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    Swal.fire({
      icon: 'error',
      title: 'Campos obligatorios',
      text: 'Es necesario completar todos los campos.',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Reintentar',
    })
  }

  const getUserMIPYMES = async () => {
    try {
      const response = await getMIPYMEByIFI(IdIFIToken)
      if (response.Success) {
        setData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getUserMIPYMES()
  }, [])

  const DataSchema = Yup.object().shape({
    IdMiPyme: Yup.number().required('Este campo es obligatorio'),
    Name: Yup.string().required('Este campo es obligatorio'),
    LastName: Yup.string().required('Este campo es obligatorio'),
    EMail: Yup.string()
      .email('El formato del email no es válido')
      .required('Este campo es obligatorio'),
  })

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      Name: '',
      LastName: '',
      EMail: '',
      IdMiPyme: '',
    },
    validationSchema: DataSchema,
    onSubmit: (values) => {
      save(values)
    },
  })

  const handleCloseModal = () => {
    setDisabled(false)
    setOpen(false)
    formik.resetForm()
  }

  const save = async (values) => {
    setDisabled(true)
    try {
      const response = await ReassignUserMiPymeNew(userIDB2C, values)
      if (response.Success) {
        if (response) {
          if (response.Success) {
            if (!response.Data.Message) {
              const mensaje = `Se ha reasignado la MIPYME.`
              Swal.fire({
                title: `Cambio de usuario exitoso`,
                text: `${mensaje}`,
                icon: 'success',
                confirmButtonColor: '#28a745',
                confirmButtonAriaLabelButtonColor: '#d33',
                confirmButtonText: 'Entendido',
              }).then((result) => {
                if (result.isConfirmed) {
                  close()
                }
              })
            }
          }
          if (response.Data.Message) {
            Swal.fire({
              title: 'Ocurrio un error al cambiar el usuario.',
              icon: 'error',
              text: response.Data.MessageInfo[0]?.Message,
              confirmButtonColor: '#28a745',
              confirmButtonAriaLabelButtonColor: '#d33',
              confirmButtonText: 'Entendido',
            })
            setDisabled(false)
          }
        }
      }
    } catch (error) {
      setDisabled(false)
      console.log(error)
    }
  }

  const close = () => {
    handleCloseModal()
    formik.resetForm()
    setDisabled(false)
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form id="register-form">
          <div className="modal-content-register">
            <Grid
              container
              spacing={1}
              style={{ fontSize: '18px', fontWeight: '400' }}
            >
              {/* <Grid item xs={false} sm={6} md={5} className={classes.image} />
              <Grid item xs={12} sm={6} md={7}> */}
              <Grid container spacing={1} style={{ padding: '24px 0px' }}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{
                    textAlign: 'center',
                    fontSize: '24px',
                    marginTop: '16px',
                    fontWeight: '500',
                  }}
                >
                  <label>Cambiar Usuario</label>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{
                    textAlign: 'center',
                    fontSize: '16px',
                    marginTop: '5px',
                  }}
                >
                  <label>
                    Complete todos los campos para cambiar el usuario
                  </label>
                </Grid>

                <Grid
                  container
                  spacing={1}
                  className="input-container-register"
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    style={{
                      marginTop: '5px',
                      color: '#848c95',
                      fontWeight: '500',
                      fontSize: '16px',
                    }}
                  >
                    <label>
                      MIPYME
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <Autocomplete
                        getOptionLabel={(option) =>
                          `${option.TaxRegistration}` +
                          ' - ' +
                          `${option.BusinessName}`
                        }
                        disablePortal
                        id="combo-box-demo"
                        options={data}
                        // value={result[0]}
                        sx={{ width: '100%' }}
                        renderInput={(params) => <TextField {...params} />}
                        onChange={(e, value) => {
                          formik.setValues({
                            ...formik.values,
                            IdMiPyme: value.IdMiPyme,
                          })
                        }}
                      />
                      {formik.errors.IdMiPyme ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.IdMiPyme}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginTop: '5px' }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      style={{
                        color: '#848c95',
                        fontWeight: '500',
                        fontSize: '16px',
                      }}
                    >
                      <label>
                        Nombre <span style={{ color: 'red' }}>*</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl style={{ width: '100%' }}>
                        <TextField
                          id="businessName"
                          style={{ width: '100%' }}
                          error={formik.errors.Name}
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('Name', e.target.value)
                          }}
                          value={formik.values.Name}
                          inputProps={{
                            maxLength: 50,
                            autoComplete: 'off',
                            // pattern: '[\\sa-zA-ZñÑäÄëËïÏöÖüÜáÁéÉíÍóÓúÚ]{0,64}',
                          }}
                        />
                        {formik.errors.Name ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.Name}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginTop: '5px' }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      style={{
                        color: '#848c95',
                        fontWeight: '500',
                        fontSize: '16px',
                      }}
                    >
                      <label>
                        Apellido
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl style={{ width: '100%' }}>
                        <TextField
                          id="businessName"
                          style={{ width: '100%' }}
                          error={formik.errors.LastName}
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('LastName', e.target.value)
                          }}
                          value={formik.values.LastName}
                          inputProps={{
                            maxLength: 50,
                            autoComplete: 'off',
                            // pattern: '[\\sa-zA-ZñÑäÄëËïÏöÖüÜáÁéÉíÍóÓúÚ]{0,64}',
                          }}
                        />
                        {formik.errors.LastName ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.LastName}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    style={{
                      marginTop: '5px',
                      color: '#848c95',
                      fontWeight: '500',
                      fontSize: '16px',
                    }}
                  >
                    <label>
                      Correo Electrónico
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <TextField
                        id="businessName"
                        style={{ width: '100%' }}
                        error={formik.errors.EMail}
                        variant="outlined"
                        onChange={(e) => {
                          formik.setFieldValue('EMail', e.target.value)
                        }}
                        value={formik.values.EMail}
                        inputProps={{
                          maxLength: 50,
                          autoComplete: 'off',
                          // pattern: '[\\sa-zA-ZñÑäÄëËïÏöÖüÜáÁéÉíÍóÓúÚ]{0,64}',
                        }}
                      />
                      {formik.errors.EMail ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.EMail}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                  <Grid className="buttonsPYME">
                    <Button
                      className="cancelButton"
                      onClick={() => handleCloseModal()}
                    >
                      Cancelar
                    </Button>

                    <Button
                      className="confirmButton"
                      disabled={disabled}
                      onClick={() => validateFormStatus()}
                    >
                      Registrar
                    </Button>
                  </Grid>
                </Grid>

                {/* <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: '5px',
                    textAlign: 'center',
                    padding: '8px 24px',
                  }}
                  justifyContent="center"
                  direction="row"
                  alignItems="center"
                >
                  <Grid item xs={12} sm={12} md={6}>
                    <Button
                      variant="contained"
                      style={{
                        background:
                          'linear-gradient(135deg, #004bce 11%, #2bce75 100%)',
                        color: 'white',
                        height: '45px',
                        width: '100%',
                      }}
                      disabled={disabled}
                      onClick={() => validateFormStatus()}
                    >
                      Registrar
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <Button
                      variant="outlined"
                      style={{ height: '45px', width: '100%' }}
                      onClick={() => handleCloseModal()}
                      className="cancelButton"
                    >
                      Cancelar
                    </Button>
                  </Grid>
                </Grid> */}
              </Grid>
            </Grid>
            {/* </Grid> */}
          </div>
        </form>
      </Modal>
    </>
  )
}

export default React.memo(ModalChangeUserRegister)
